import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class OutputStackItem extends EquatableKeyStackItem {
    asOutput() {
        return this.value;
    }
}

//# sourceMappingURL=OutputStackItem.js.map
